"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var d3 = require("d3");
var _1 = require(".");
var __1 = require("..");
var element_1 = require("../element");
var utils_1 = require("../template/utils");
var ForceDirect = /** @class */ (function (_super) {
    __extends(ForceDirect, _super);
    function ForceDirect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.needsRender = false;
        return _this;
    }
    ForceDirect.parseAttributeValue = function (attr, value) {
        switch (attr) {
            case "_nodeFunc":
            case "_linkFunc":
            case "_forceCollide":
            case "_forceCenter":
            case "_forceLink":
            case "_forceManyBody":
            case "_forceRadial":
                return utils_1.parseFunc(value);
            case "_alpha":
            case "_alphaMin":
            case "_alphaDecay":
            case "_alphaTarget":
            case "_velocityDecay":
                return utils_1.parseNumberWithAuto(value);
            case "_radius":
                return utils_1.parseNumberOrFunc(value);
            case "_updateOnTick":
                return utils_1.parseBoolean(value);
            default:
                return _super.parseAttributeValue.call(this, attr, value);
        }
    };
    ForceDirect.prototype.defaultOptions = function () {
        return {
            _forceCenter: d3.forceCenter(0, 0),
            _forceCollide: d3.forceCollide(function (d) { return d.group + 8; }).iterations(16),
            _forceLink: d3.forceLink().id(function (d) { return d.id; }),
            _forceManyBody: d3.forceManyBody(),
            _forceRadial: null,
            _forceX: null,
            _forceY: null,
            _nodeFunc: function (d) { return d.nodes; },
            _linkFunc: function (d) { return d.links; },
            _radius: 5,
            _alpha: 1,
            _alphaMin: 0.001,
            _alphaDecay: 1 - Math.pow(0.001, 1 / 300),
            _alphaTarget: 0,
            _velocityDecay: 0.4,
            _updateOnTick: true,
        };
    };
    ForceDirect.prototype.init = function () {
        var _this = this;
        this._tooltip = __1.tooltip.create("nodetip");
        this._linkGroups = this.appendGroupT(_1.Component).data([]).options({
            _x: function (_) { return _this._cachedWidth / 2; },
            _y: function (_) { return _this._cachedHeight / 2; },
        });
        this._links = this._linkGroups.appendT(element_1.Path).options({
            d: function (d) { return "M" + d.source.x + "," + d.source.y + " L" + d.target.x + "," + d.target.y; },
            stroke: "white",
        });
        this._nodeGroups = this.appendGroupT(_1.Component).data([]).options({
            _x: function (d) { return d.x + _this._cachedWidth / 2; },
            _y: function (d) { return d.y + _this._cachedHeight / 2; },
        });
        this._nodes = this._nodeGroups.appendT(element_1.Circle).options({
            _r: function (d) { return _this._radius(d); },
            _$postAppend: function () {
                _this._tooltip.attachTo(_this._nodeGroups.dom)
                    .renderHTML(function (d) {
                    return "Index: " + d.index;
                });
            },
        });
    };
    ForceDirect.prototype.postOptionsUpdate = function () {
        this._linkFunc = this.getOption("_linkFunc");
        this._nodeFunc = this.getOption("_nodeFunc");
        var radius = this.getOption("_radius");
        this._isConstR = !isNaN(radius);
        this._radius = this._isConstR ? (function (_) { return radius; }) : radius;
    };
    ForceDirect.prototype.render = function (isRoot) {
        var _this = this;
        if (isRoot === void 0) { isRoot = true; }
        var ids = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            ids[_i - 1] = arguments[_i];
        }
        if (this.needsRender) {
            _super.prototype.render.call(this, ids);
            this.needsRender = false;
        }
        else {
            if (!this._preRender()) {
                return;
            }
            var nodes_1 = this._nodeFunc(this.datum);
            var links_1 = this._linkFunc(this.datum);
            var simulation = d3.forceSimulation()
                .alpha(this.getOption("_alpha"))
                .alphaMin(this.getOption("_alphaMin"))
                .alphaDecay(this.getOption("_alphaDecay"))
                .alphaTarget(this.getOption("_alphaTarget"))
                .velocityDecay(this.getOption("_velocityDecay"));
            simulation
                .force("collide", this.getOption("_forceCollide"))
                .force("charge", this.getOption("_forceManyBody"))
                .force("center", this.getOption("_forceCenter"))
                .force("r", this.getOption("_forceRadial"))
                .force("link", this.getOption("_forceLink"));
            simulation.nodes(nodes_1);
            simulation.force("link").links(links_1);
            var events = (this.getOption("_updateOnTick") ? "tick " : "") + "end";
            simulation.on(events, function () {
                _this.needsRender = true;
                _this.render();
                _this._linkGroups.markAllDirty(["_x", "_y"]).data(links_1).render();
                _this._nodeGroups.markAllDirty(["_x", "_y"]).data(nodes_1).render();
            });
        }
    };
    ForceDirect.prototype.prepare = function () {
        this._cachedHeight = this._getGeometry("_height", false);
        this._cachedWidth = this._getGeometry("_width", true);
        this.setupProxy({
            circle: "_nodes",
            line: "_links",
        });
    };
    return ForceDirect;
}(_1.Component));
exports.ForceDirect = ForceDirect;
//# sourceMappingURL=force-direct.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/bvd3/dist/component/force-direct.js
// module id = 1151
// module chunks = 0 1